import { PrescriptionRenewalStatus } from "../Common/PrescriptionRenewalStatus";
import { PrescriptionRenewalSettings } from "./Settings/PrescriptionRenewalSettings";

class PrescriptionRenewalFilterSettingModel {
    public dateFrom: Date = null;
    public dateTo: Date = null;
    public queryPageSize: number = 50;
    public selectedSitesIds: string[] = [];
    public selectedPhysiciansIds: string[] = (() => {
        const currentEmployee = sessionStore.getCurrentEmployee();

        if (!currentEmployee || !sessionStore.isIntervenor(currentEmployee.getIssuingOrgRule()?.Title) || IsNullOrWhiteSpace(currentEmployee.ContactId)) {
            return [];
        }

        return [currentEmployee.ContactId];
    })();

    public selectedStatus: PrescriptionRenewalStatus[] = [PrescriptionRenewalStatus.Pending, PrescriptionRenewalStatus.New];
    public clinicianSearchText: string = "";

    public static fromCacheModel(prescriptionRenewalSettingsResponse: PrescriptionRenewalSettings): PrescriptionRenewalFilterSettingModel {
        if (!prescriptionRenewalSettingsResponse)
            return null;

        const prescriptionRenewalModel = new PrescriptionRenewalFilterSettingModel();
        prescriptionRenewalModel.dateFrom = prescriptionRenewalSettingsResponse.DateFrom;
        prescriptionRenewalModel.dateTo = prescriptionRenewalSettingsResponse.DateTo;
        prescriptionRenewalModel.queryPageSize = prescriptionRenewalSettingsResponse.QueryPageSize;
        prescriptionRenewalModel.selectedSitesIds = prescriptionRenewalSettingsResponse.SelectedSitesIds;
        prescriptionRenewalModel.selectedPhysiciansIds = prescriptionRenewalSettingsResponse.SelectedPhysiciansIds;
        prescriptionRenewalModel.selectedStatus = prescriptionRenewalSettingsResponse.SelectedStatus;
        prescriptionRenewalModel.clinicianSearchText = prescriptionRenewalSettingsResponse?.ClinicianSearchText ?? "";

        return prescriptionRenewalModel;
    }

    public static toCacheModel(prescriptionRenewalSettings: PrescriptionRenewalFilterSettingModel): PrescriptionRenewalSettings {
        return {
            DateFrom: prescriptionRenewalSettings.dateFrom,
            DateTo: prescriptionRenewalSettings.dateTo,
            QueryPageSize: prescriptionRenewalSettings.queryPageSize,
            SelectedSitesIds: prescriptionRenewalSettings.selectedSitesIds,
            SelectedPhysiciansIds: prescriptionRenewalSettings.selectedPhysiciansIds,
            SelectedStatus: prescriptionRenewalSettings.selectedStatus,
            ClinicianSearchText: prescriptionRenewalSettings?.clinicianSearchText ?? ""
        };
    }
}

export { PrescriptionRenewalFilterSettingModel };
